import { DayPicker, DayPickerProps } from 'react-day-picker';

import { ChevronIcon } from '../assets';
import { MAX_DATE, MIN_DATE, cn } from '../lib';
import { buttonVariants } from './button';

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: DayPickerProps) {
  return (
    <DayPicker
      fromDate={MIN_DATE}
      toDate={MAX_DATE}
      captionLayout="dropdown"
      showOutsideDays={showOutsideDays}
      className={cn('w-full p-3', className)}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month: 'space-y-4 mx-auto',
        caption: 'flex justify-center pt-1 relative items-center',
        caption_label: 'hidden',
        nav: 'space-x-1 flex items-center',
        nav_button: cn(
          buttonVariants({ variant: 'outline' }),
          'h-7 w-7 p-0 bg-surface-00-transparent',
        ),
        table: 'w-full border-collapse space-y-1',
        head_row: 'flex',
        head_cell: 'text-muted-foreground w-[42px] font-normal text-base',
        row: 'flex w-full mt-2',
        cell: 'bg-surface-00-transparent size-[42px] text-center text-base p-0 relative first:[&:has([aria-selected])]:rounded-full last:[&:has([aria-selected])]:rounded-full focus-within:relative focus-within:z-20',
        day: cn(
          buttonVariants({ variant: 'ghost' }),
          'size-[42px] p-0 font-normal transition-all  ease-in-out duration-200 aria-selected:opacity-100 rounded-full',
        ),
        day_range_start: 'day-range-start !bg-brand-500 !rounded-full',
        day_range_end: 'day-range-end !bg-brand-500  !rounded-full',
        day_selected: 'text-base-500 focus:bg-brand-500',
        day_today:
          '!bg-brand-300 hover:text-base-500 text-brand-500 aria-selected:text-base-500',
        day_outside:
          'day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground',
        day_disabled: 'text-muted-foreground opacity-50',
        day_range_middle: 'aria-selected:bg-light-base',
        day_hidden: 'invisible',
        caption_dropdowns: 'w-full flex gap-2 flex-row-reverse justify-between',
        dropdown:
          'transition-color ease-in-out duration-200 bg-neutral-800 text-base-500 p-1 px-2 rounded-lg appearance-none outline-none cursor-pointer hover:bg-neutral-700',
        vhidden: 'hidden',
        ...classNames,
      }}
      components={{
        IconLeft: () => <ChevronIcon className="size-4 rotate-180" />,
        IconRight: () => <ChevronIcon className="size-4" />,
      }}
      {...props}
    />
  );
}

Calendar.displayName = 'Calendar';

export { Calendar };
